import { RuleValidation } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FreeDeliveryRuleState } from './types'

export function validateFreeDeliveryRule(rule: FreeDeliveryRuleState): RuleValidation {
	if (rule.threshold === null || rule.threshold <= 0) {
		return { isValid: false, errors: { threshold: 'invalid' } }
	}
	return { isValid: true, errors: {} }
}
